<div [class]="isLoading?'page-loader':'page-loder d-none'"></div>
<form [formGroup]="siteContactForm" (ngSubmit)="onSubmit()" id="trade-register-form"
  (keydown.enter)="$event.preventDefault()">
  <div class="modal-header">
    <h4 class="modal-title">Update Site Contact</h4>
  </div>
  <div class="modal-body">
    <div class="modal-body-inner">
      <div class="add-user-form">
        <div class="row">
          <div class="col">
            <div class="form-field form-group custom-checkbox">
              <div class="custom-checkbox-inner">
                <input type="checkbox" id="account-holder" data-md-icheck (change)="accountHolderCheck($event)" [checked]="accountHolder" />
                <span class="checkmark"></span>
                <label class="checkbox-container grey-label" for="account-holder">Account Holder</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-field form-group">
              <label class="grey-label">Site Contact Name <span class="required-field">*</span></label>
              <input formControlName="name"
                [ngClass]="{ 'is-invalid': da?.name?.invalid && (da.name.dirty || da.name.touched ||submitted), 'is-valid': !da?.name?.invalid && (da.name.dirty || da.name.touched ||submitted)}"
                class="form-control text-align" type="text" required placeholder="Enter site contact name" />
              <span class=" invalid-feedback" role="alert"
                *ngIf="da?.name?.invalid && (da.name.dirty || da.name.touched ||submitted)">
                <span *ngIf="da.name.errors!== null && da.name.errors.required">Enter site contact name.</span>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-field form-group">
              <label class="grey-label">Site Contact Number <span class="required-field">*</span></label>
              <input formControlName="number" [imask]="{mask: '0000 000 000',lazy:false}" [unmask]="true"
                [ngClass]="{ 'is-invalid': da.number?.invalid && (da.number.dirty || da.number.touched ||submitted), 'is-valid': !da.number.invalid && (da.number.dirty || da.number.touched ||submitted)}"
                class="form-control text-align" type="text" required placeholder="Enter site contact number"
                numbersOnly="true" />
              <span class=" invalid-feedback" role="alert"
                *ngIf="da.number?.invalid && (da.number.dirty || da.number.touched ||submitted)">
                <span *ngIf="da.number.errors!== null && da.number.errors.required">Enter site contact number.</span>
                <span *ngIf="da.number.errors?.minlength && !da['number'].errors?.mobileNotValid">Enter at least 10 characters.</span>
                <span *ngIf="!da['number'].errors?.required && da['number'].errors?.mobileNotValid">Must be a valid Australian mobile phone number.</span>
                <span *ngIf="da.number.errors?.apiError">{{da.number.errors?.apiError}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-field form-group">
              <label class="grey-label">Site Contact Email</label>
              <input formControlName="email"
                [ngClass]="{ 'is-invalid': da?.email?.invalid && (da.email.dirty || da.email.touched ||submitted), 'is-valid': !da?.email?.invalid && (da.email.dirty || da.email.touched ||submitted)}"
                class="form-control text-align" type="email" placeholder="Enter site contact email" />
              <span class=" invalid-feedback" role="alert" *ngIf="da.email.errors?.email">
                <span>
                  Enter valid email address.
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="dark-bordered-btn dont-send-btn" data-dismiss="modal" (click)="cancel()">Cancel
    </button>
    <button type="submit" class="submit-btn-grey status-modal-save">Update</button>
  </div>
</form>